import options from './things-list.component';

export default {
    selector: 'dtThingsList',
    options
};
